import { render, staticRenderFns } from "./addSubcuenta.vue?vue&type=template&id=0390e258&scoped=true"
import script from "./addSubcuenta.vue?vue&type=script&lang=js"
export * from "./addSubcuenta.vue?vue&type=script&lang=js"
import style0 from "./addSubcuenta.vue?vue&type=style&index=0&id=0390e258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0390e258",
  null
  
)

export default component.exports